<div class="widget widget_services p-a20">
    <div class="text-left m-b30">
        <h3 class="widget-title">Categories</h3>
        
    </div>
    <ul>
        <li *ngFor="let object of data"><a routerLink="/blog/blog-grid">{{object.title}}</a><span class="badge">{{object.badge}}</span></li>                                            
    </ul>
</div>